module.exports = __webpack_public_path__ + "static/media/avatar_background.0811f40d.jpg";